module.exports = __webpack_public_path__ + "img/RS-J-1.1e190ada.svg";